<div class="web-recorder-layout">
  <ze-web-recorder-session>

    <!-- Toolbar slot — step actions, add step, Record. Only once a session exists. -->
    <ze-simulator-toolbar recorder-toolbar *ngIf="recorderSession.sessionId"></ze-simulator-toolbar>

    <!-- Both project into the same sidebar-slot cell; *ngIf shows only one at a time.
         No session: read-only browsing of already-saved steps. -->
    <ze-web-recorder-saved-steps recorder-sidebar *ngIf="!recorderSession.sessionId"></ze-web-recorder-saved-steps>

    <!-- Session active: full recording UI (step list + selected step's commands). -->
    <ze-web-recorded-steps recorder-sidebar *ngIf="recorderSession.sessionId" [isRecording]="recorderSession.isRecording"></ze-web-recorded-steps>

  </ze-web-recorder-session>
</div>
